import { createContext } from "react";

let defaultValue = Object() ;

export const AppContext = createContext( defaultValue ) ;
